import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useProductStore } from '../../store/useProductStore';
import { TableCell, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ProductManageTable() {

  const navigate = useNavigate()
  const [product, setProduct] = useState([])
  const { getRecentProduct, loading } = useProductStore()

  const getRecentProductFunction = async () => {
    try {
      const product = await getRecentProduct(1, 5, '', '')
      console.log("product", product)
      setProduct(product)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getRecentProductFunction()
  }, [])
  return (
    <section id="products-section" className="mt-12">
      <div className="flex items-center justify-between mb-5">
        <div className="text-lg font-semibold text-[#1e293b]">
          Product Management
        </div>
        <div className="flex items-center gap-3">
          {/* <input
            type="text"
            placeholder="Search products..."
            className="border border-[#e5e7eb] rounded-lg px-4 py-2 text-sm focus:border-[#3b82f6] focus:ring-[#3b82f6] focus:outline-none"
          /> */}
          <button
            onClick={() =>navigate("/product/add")}
            className="flex items-center gap-2 bg-[#3b82f6] text-white px-5 py-2 rounded-lg font-semibold hover:bg-[#2563eb] transition">
            <i className="fa-solid fa-plus"></i> Add Product
          </button>
        </div>
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#e5e7eb] bg-white">
        {
          <table className="min-w-full">
            <thead>
              <tr className="bg-[#f1f5f9] text-[#94a3b8] text-sm font-medium">
                <th className="text-left px-6 py-3">Product</th>
                <th className="text-left px-6 py-3">Category</th>
                <th className="text-left px-6 py-3">Price</th>
                <th className="text-left px-6 py-3">Stock</th>
                <th className="text-left px-6 py-3">Brand</th>
                <th className="text-left px-6 py-3">SKU</th>
                <th className="text-left px-6 py-3">Status</th>
                {/* <th className="text-left px-6 py-3">Actions</th> */}
              </tr>
            </thead>
            <tbody className="text-[#1e293b]">

              {loading ? (
                Array.from({ length: 5 }).map((_, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {Array.from({ length: 8 }).map((_, colIndex) => (
                      <TableCell key={colIndex}>
                        <Skeleton variant="text" animation="wave" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                (product || []).map((ele, i) => (
                  <tr className="border-b border-[#f1f5f9] hover:bg-[#f9fafb]" key={i}>
                    <td className="flex items-center gap-3 px-6 py-4">
                      <div className="w-10 h-10 bg-[#eff6ff] rounded-lg flex items-center justify-center">
                        <img
                          src={ele.images[0]}
                          alt="Product"
                          className="w-16 h-16 object-cover rounded"
                        />
                      </div>
                      {ele?.name}
                    </td>
                    <td className="px-6 py-4">{ele?.categoryName}</td>
                    <td className="px-6 py-4">
                      {ele?.attributes?.length > 0 && ele.attributes[0]?.size_attribute?.length > 0
                        ? `$${ele.attributes[0].size_attribute[0]?.retailPrice}`
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4">
                      {ele?.attributes?.length > 0 && ele.attributes[0]?.size_attribute?.length > 0
                        ? `${ele.attributes[0].size_attribute[0]?.stock_quantity}`
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4">{ele?.brand}</td>
                    <td className="px-6 py-4">{ele?.sku_id}</td>
                    <td className="px-6 py-4">
                      <td className="px-6 py-4">
                        {ele?.is_featured ? (
                          <span className="bg-[#d1fae5] text-[#10b981] px-3 py-1 rounded-full text-xs font-bold">
                            Active
                          </span>
                        ) : (
                          <span className="bg-[#fee2e2] text-[#ef4444] px-3 py-1 rounded-full text-xs font-bold">
                            Inactive
                          </span>
                        )}
                      </td>

                    </td>
                    {/* <td className="px-6 py-4">
                      <button className="text-[#3b82f6] hover:underline mr-2">
                        Edit
                      </button>
                      <button className="text-[#ef4444] hover:underline">
                        Delete
                      </button>
                    </td> */}
                  </tr>
                ))
              )
              }
            </tbody>
          </table>
          || <Skeleton count={10} />}
      </div>
    </section>
  )
}
